// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","455":"component---src-templates-blog-post-tsx","466":"component---src-pages-blogs-tsx"}[chunkId] + "-" + {"245":"8d7531a2bc20f6e8d0db","453":"3674054577f0af88f6f7","455":"c34f5bf28d44684e13e3","466":"86b5b6bbd9aab9945734"}[chunkId] + ".js";
};